module.exports = __webpack_public_path__ + "static/media/gmail.ae741e46.svg";